import { Container } from '@/components/shared/Container'
import { DatoImage } from '@/elements/global/DatoImage'
import styled from 'styled-components'
import { WhitepaperArticleRecord } from 'types'

const StyledWhitepaperArticleImage = styled.div`
  margin: 80px 0;
  img {
    border-radius: 4px;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    margin: 40px 0;
    img {
      border-radius: 0;
    }
  }
`
export const WhitepaperArticleImage = ({ article }: { article: WhitepaperArticleRecord }) => {
  return (
    <Container $size="wide" $padding="no-mobile">
      <StyledWhitepaperArticleImage>
        <DatoImage data={article.featuredImage.responsiveImage} />
      </StyledWhitepaperArticleImage>
    </Container>
  )
}
